import { render, staticRenderFns } from "./PDPIntro.vue?vue&type=template&id=6ad83ba6&scoped=true&"
import script from "./PDPIntro.vue?vue&type=script&lang=ts&"
export * from "./PDPIntro.vue?vue&type=script&lang=ts&"
import style0 from "./PDPIntro.vue?vue&type=style&index=0&id=6ad83ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad83ba6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsRatingStarsBar: require('/var/www/packages/theme/components/atoms/RatingStarsBar.vue').default,IconsCheckmark16px: require('/var/www/packages/theme/components/icons/checkmark/Checkmark16px.vue').default,AtomsKELabel: require('/var/www/packages/theme/components/atoms/KELabel.vue').default})
